import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { buildWhatsAppLink } from '@/utils/whatsapp'

const highlights = [
  { id: 'h1', icon: 'ri-heart-3-line' },
  { id: 'h2', icon: 'ri-movie-2-line' },
  { id: 'h3', icon: 'ri-flight-takeoff-line' },
  { id: 'h4', icon: 'ri-image-2-line' },
]

export default function WeddingIntroSection() {
  const { t } = useTranslation()

  return (
    <section id="wedding-intro" className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-primary-500" />
              <span className="section-label text-primary-700 text-[11px] md:text-xs font-medium">
                {t('wedding.intro.label')}
              </span>
            </div>

            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
              {t('wedding.intro.title')}
            </h2>

            <p className="mt-6 text-base text-foreground-600 leading-relaxed">{t('wedding.intro.para1')}</p>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">{t('wedding.intro.para2')}</p>

            <div className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {highlights.map((item) => (
                <div
                  key={item.id}
                  className="rounded-lg border border-background-200 bg-background-100/60 p-4 flex flex-col items-center text-center"
                >
                  <span className="w-11 h-11 rounded-full flex items-center justify-center bg-accent-100 text-accent-700 mb-2">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <span className="text-xs md:text-sm font-medium text-foreground-800">
                    {t(`wedding.intro.highlights.${item.id}`)}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <a
                href={buildWhatsAppLink(t('common.enquireMessage', { topic: t('nav.wedding') }))}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-whatsapp-line text-lg" />
                {t('common.enquire')}
              </a>
              <Link
                to="/gallery"
                className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md border border-background-300 text-foreground-800 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:border-primary-400 hover:text-primary-700 transition-colors"
              >
                <i className="ri-image-2-line text-lg" />
                {t('common.seeOurWork')}
              </Link>
            </div>
          </div>

          <div className="order-1 lg:order-2 grid grid-cols-2 gap-4 md:gap-5">
            <div className="col-span-2 rounded-lg overflow-hidden h-56 md:h-72 border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20and%20groom%20in%20traditional%20red%20silk%20saree%20and%20veshti%20during%20a%20warm%20temple%20wedding%2C%20golden%20light%2C%20candid%20cinematic%20editorial%20photography%2C%20rich%20amber%20tones%2C%20soft%20bokeh%20background&width=1000&height=620&seq=shabi-wedding-intro-01&orientation=landscape"
                alt="Tamil bride and groom during a traditional wedding by Shabi Media"
                title="Traditional South Indian wedding photography by Shabi Media"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-lg overflow-hidden h-44 md:h-56 border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20portrait%20with%20temple%20gold%20jewellery%20and%20jasmine%20flowers%2C%20warm%20golden%20hour%20backlight%2C%20elegant%20luxury%20photography%2C%20rich%20amber%20tones%2C%20soft%20dark%20background&width=700&height=800&seq=shabi-wedding-intro-02&orientation=portrait"
                alt="Bridal portrait with temple jewellery by Shabi Media"
                title="Bridal portrait with temple jewellery — Shabi Media wedding photography"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-lg overflow-hidden h-44 md:h-56 bg-primary-950 flex flex-col items-center justify-center text-center p-5">
              <i className="ri-double-quotes-l text-primary-400 text-3xl mb-3" />
              <p className="font-heading italic text-background-100 text-lg md:text-xl leading-snug">
                {t('wedding.intro.quote')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}